import BlockContent from '@sanity/block-content-to-react';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ALL_LANGS } from '../../constants';
import { getSerializers } from '../../serializers';
import { AreaOfExpertise } from '../../templates/AreaOfExpertisePage';
import { Service } from '../../templates/ServicePage';
import { RawPortableText } from '../../types/types';
import { localize } from '../../utils/sanity';

export interface GenericPortableTextProps {
  blocks: RawPortableText;
  className?: string;
}

interface QueryData {
  allSanityAreaOfExpertise: {
    nodes: Array<AreaOfExpertise>;
  };
  allSanityService: {
    nodes: Array<Service>;
  };
}

const GenericPortableText = ({
  blocks,
  className,
}: GenericPortableTextProps): React.ReactElement => {
  const queryData = useStaticQuery<QueryData>(graphql`
    {
      allSanityAreaOfExpertise(sort: { orderRank: ASC }) {
        nodes {
          ...AreaOfExpertise
        }
      }
      allSanityService(sort: { orderRank: ASC }) {
        nodes {
          ...Service
        }
      }
    }
  `);

  const { i18n, t } = useTranslation();

  const langs = [i18n.language, ...ALL_LANGS.filter(lang => lang !== i18n.language)];
  const localizedData: QueryData = localize(queryData, langs);

  const { allSanityAreaOfExpertise, allSanityService } = localizedData;

  return (
    <BlockContent
      blocks={blocks}
      className={className}
      renderContainerOnSingleChild
      serializers={getSerializers({
        areasOfExpertise: allSanityAreaOfExpertise.nodes,
        services: allSanityService.nodes,
      })}
    />
  );
};

export default GenericPortableText;
